import UnicoreImage1 from "./Assets/Unicore/image1.png";
import UnicoreImage2 from "./Assets/Unicore/image2.png";
import UnicoreImage3 from "./Assets/Unicore/image3.png";
import UnicoreImage4 from "./Assets/Unicore/image4.png";
import UnicoreImage5 from "./Assets/Unicore/image5.png";
import UnicoreImage6 from "./Assets/Unicore/image6.png";
import UnicoreImage7 from "./Assets/Unicore/image7.png";
import UnicoreImage8 from "./Assets/Unicore/image8.png";
import UnicoreImage9 from "./Assets/Unicore/image9.png";
import UnicoreImage10 from "./Assets/Unicore/image10.png";

import KiteesImage1 from "./Assets/Kitees/image1.png";
import KiteesImage2 from "./Assets/Kitees/image2.png";
import KiteesImage3 from "./Assets/Kitees/image3.png";
import KiteesImage4 from "./Assets/Kitees/image4.png";
import KiteesImage5 from "./Assets/Kitees/image5.png";
import KiteesImage6 from "./Assets/Kitees/image6.png";
import KiteesImage7 from "./Assets/Kitees/image7.png";
import KiteesImage8 from "./Assets/Kitees/image8.png";
import KiteesImage9 from "./Assets/Kitees/image9.png";
import KiteesImage10 from "./Assets/Kitees/image10.png";

import FutureMindsImage1 from "./Assets/Futureminds/image1.png";
import FutureMindsImage2 from "./Assets/Futureminds/image2.png";
import FutureMindsImage3 from "./Assets/Futureminds/image3.png";
import FutureMindsImage4 from "./Assets/Futureminds/image4.png";
import FutureMindsImage5 from "./Assets/Futureminds/image5.png";
import FutureMindsImage6 from "./Assets/Futureminds/image6.png";
import FutureMindsImage7 from "./Assets/Futureminds/image7.png";
import FutureMindsImage8 from "./Assets/Futureminds/image8.png";

import TextNTalkImage1 from "./Assets/Textntalk/image1.jpg";
import TextNTalkImage2 from "./Assets/Textntalk/image2.jpg";
import TextNTalkImage3 from "./Assets/Textntalk/image3.jpg";
import TextNTalkImage4 from "./Assets/Textntalk/image4.jpg";
import TextNTalkImage5 from "./Assets/Textntalk/image5.jpg";
import TextNTalkImage6 from "./Assets/Textntalk/image6.jpg";
import TextNTalkImage7 from "./Assets/Textntalk/image7.jpg";
import TextNTalkImage8 from "./Assets/Textntalk/image8.jpg";
import TextNTalkImage9 from "./Assets/Textntalk/image9.jpg";
import TextNTalkImage10 from "./Assets/Textntalk/image10.jpg";

import GroceryImage1 from "./Assets/Grocery/image1.png";
import GroceryImage2 from "./Assets/Grocery/image2.png";
import GroceryImage3 from "./Assets/Grocery/image3.png";
import GroceryImage4 from "./Assets/Grocery/image4.png";
import GroceryImage5 from "./Assets/Grocery/image5.png";
import GroceryImage6 from "./Assets/Grocery/image6.png";
import GroceryImage7 from "./Assets/Grocery/image7.png";

import StudentMarksImage1 from "./Assets/Studentmarks/image1.png";
import StudentMarksImage2 from "./Assets/Studentmarks/image2.png";
import StudentMarksImage3 from "./Assets/Studentmarks/image3.png";
import StudentMarksImage4 from "./Assets/Studentmarks/image4.png";
import StudentMarksImage5 from "./Assets/Studentmarks/image5.png";

import ProjectNestImage1 from "./Assets/Projectnest/image1.png";
import ProjectNestImage2 from "./Assets/Projectnest/image2.png";
import ProjectNestImage3 from "./Assets/Projectnest/image3.png";
import ProjectNestImage4 from "./Assets/Projectnest/image4.png";
import ProjectNestImage5 from "./Assets/Projectnest/image5.png";
import ProjectNestImage6 from "./Assets/Projectnest/image6.png";
import ProjectNestImage7 from "./Assets/Projectnest/image7.png";
import ProjectNestImage8 from "./Assets/Projectnest/image8.png";

import VishwalataratiImage1 from "./Assets/Vishwalatarati/image1.png";
import VishwalataratiImage2 from "./Assets/Vishwalatarati/image2.png";
import VishwalataratiImage3 from "./Assets/Vishwalatarati/image3.png";
import VishwalataratiImage4 from "./Assets/Vishwalatarati/image4.png";
import VishwalataratiImage5 from "./Assets/Vishwalatarati/image5.png";
import VishwalataratiImage6 from "./Assets/Vishwalatarati/image6.png";
import VishwalataratiImage7 from "./Assets/Vishwalatarati/image7.png";
import VishwalataratiImage8 from "./Assets/Vishwalatarati/image8.png";
import VishwalataratiImage9 from "./Assets/Vishwalatarati/image9.png";
import VishwalataratiImage10 from "./Assets/Vishwalatarati/image10.png";

import ChargeBayImage1 from "./Assets/ChargeBay/image1.png";
import ChargeBayImage2 from "./Assets/ChargeBay/image2.png";
import ChargeBayImage3 from "./Assets/ChargeBay/image3.png";
import ChargeBayImage4 from "./Assets/ChargeBay/image4.png";
import ChargeBayImage5 from "./Assets/ChargeBay/image5.png";
import ChargeBayImage6 from "./Assets/ChargeBay/image6.png";
import ChargeBayImage7 from "./Assets/ChargeBay/image7.png";
import ChargeBayImage8 from "./Assets/ChargeBay/image8.png";
import ChargeBayImage9 from "./Assets/ChargeBay/image9.png";
import ChargeBayImage10 from "./Assets/ChargeBay/image10.png";
import ChargeBayImage11 from "./Assets/ChargeBay/image11.png";
import ChargeBayImage12 from "./Assets/ChargeBay/image12.png";
import ChargeBayImage13 from "./Assets/ChargeBay/image13.png";
import ChargeBayImage14 from "./Assets/ChargeBay/image14.png";
import ChargeBayImage15 from "./Assets/ChargeBay/image15.png";
import ChargeBayImage16 from "./Assets/ChargeBay/image16.png";

import WaterManagerImage1 from "./Assets/WaterManager/image1.jpg"
import WaterManagerImage2 from "./Assets/WaterManager/image2.jpg"
import WaterManagerImage3 from "./Assets/WaterManager/image3.jpg"
import WaterManagerImage4 from "./Assets/WaterManager/image4.jpg"
import WaterManagerImage5 from "./Assets/WaterManager/image5.jpg"
import WaterManagerImage6 from "./Assets/WaterManager/image6.jpg"
import WaterManagerImage7 from "./Assets/WaterManager/image7.jpg"
import WaterManagerImage8 from "./Assets/WaterManager/image8.jpg"
import WaterManagerImage9 from "./Assets/WaterManager/image9.jpg"
import WaterManagerImage10 from "./Assets/WaterManager/image10.jpg"
import WaterManagerImage11 from "./Assets/WaterManager/image11.jpg"

import AnmolTravelsImage1 from "./Assets/Anmol Travels/image1.png";
import AnmolTravelsImage2 from "./Assets/Anmol Travels/image2.png";
import AnmolTravelsImage3 from "./Assets/Anmol Travels/image3.png";
import AnmolTravelsImage4 from "./Assets/Anmol Travels/image4.png";
import AnmolTravelsImage5 from "./Assets/Anmol Travels/image5.png";
import AnmolTravelsImage6 from "./Assets/Anmol Travels/image6.png";
import AnmolTravelsImage7 from "./Assets/Anmol Travels/image7.png";
import AnmolTravelsImage8 from "./Assets/Anmol Travels/image8.png";
import AnmolTravelsIImage9 from "./Assets/Anmol Travels/image9.png";
import AnmolTravelsImage10 from "./Assets/Anmol Travels/image10.png";

export const projects = [
    {
        id: 1,
        title: "Unicore",
        category: "Educational Tool",
        description:
            "A modern University Management System designed to efficiently handle academic and administrative tasks for mid-level institutions",
        fullDescription:
            "The University Management System is a modern, user-friendly platform built to streamline and manage day-to-day academic and administrative operations for mid-sized universities. It includes features like student dashboard, admin panel, course scheduling, events management, notice board, class-test result, and library management — all within a centralized dashboard. Designed with a clean UI and scalable architecture, this system simplifies coordination across departments and improves overall institutional efficiency.",
        tech: ["React", "Node.js", "Firebase", "Firestore"],
        link: "https://unicore-8605.vercel.app",
        images: [
            UnicoreImage1,
            UnicoreImage2,
            UnicoreImage3,
            UnicoreImage4,
            UnicoreImage5,
            UnicoreImage6,
            UnicoreImage7,
            UnicoreImage8,
            UnicoreImage9,
            UnicoreImage10,
        ],
        color: "from-purple-500 to-pink-500",
    },
    {
        id: 2,
        title: "Kitees",
        category: "E-commerce",
        description:
            "A modern e-commerce platform for electronics kits and components, tailored for electronics students and enthusiasts.",
        fullDescription:
            "An innovative e-commerce platform crafted specifically for electronics students and hobbyists, offering a wide range of electronic kits, components, and DIY tools. The platform features a clean, intuitive interface with smart filtering, detailed product information, student-friendly pricing, and secure checkout. Designed to support academic projects and hands-on learning, it simplifies the process of finding and purchasing quality components needed for practical electronics work.",
        tech: ["React", "Node.js", "Firebase", "Framer Motion", "Firestore"],
        link: "https://kitees.vercel.app",
        images: [
            KiteesImage1,
            KiteesImage2,
            KiteesImage3,
            KiteesImage4,
            KiteesImage5,
            KiteesImage6,
            KiteesImage7,
            KiteesImage8,
            KiteesImage9,
            KiteesImage10,
        ],
        color: "from-blue-500 to-cyan-500",
    },
    {
        id: 3,
        title: "ChargeBay",
        category: "Corporate Website",
        description:
            "High-end, modern website with sleek design and interactive features showcasing ChargeBay’s EV charging solutions.",
        fullDescription:
            "An award-winning company website featuring cutting-edge animations and modern design principles. Built for a company organizing summer vacation programs for children, with interactive elements, engaging user experience, advanced CSS animations, and optimized performance for all devices.",
        tech: ["React", "Framer Motion", "GSAP", "CSS3"],
        link: "https://ChargeBay.app",
        images: [
            ChargeBayImage1,
            ChargeBayImage2,
            ChargeBayImage3,
            ChargeBayImage4,
            ChargeBayImage5,
            ChargeBayImage6,
            ChargeBayImage7,
            ChargeBayImage8,
            ChargeBayImage9,
            ChargeBayImage10,
            ChargeBayImage11,
            ChargeBayImage12,
            ChargeBayImage13,
            ChargeBayImage14,
            ChargeBayImage15,
            ChargeBayImage16,
        ],
        color: "from-green-500 to-teal-500",
    },
    {
        id: 4,
        title: "WaterManager",
        category: "Business Tool",
        isApplication: true,
        description: "High-end business application with intuitive interface for managing water bottle shop operations, customer deliveries, payments, and billing.",
        fullDescription: "WaterManager is a powerful and user-friendly application designed specifically for water bottle shop owners. It streamlines daily operations by helping manage customer lists, track deliveries, record payments, and generate billing effortlessly. With a modern and clean interface, interactive elements, and smooth navigation, the app ensures efficient management while providing an engaging user experience. Built with optimized performance and reliability in mind, WaterManager makes running a water delivery business simpler, faster, and more organized.",
        tech: ["React Native", "Firestore", "Expo Native"],
        link: "https://github.com/akhil-8605/WaterManager",
        images: [
            WaterManagerImage1,
            WaterManagerImage2,
            WaterManagerImage3,
            WaterManagerImage4,
            WaterManagerImage5,
            WaterManagerImage6,
            WaterManagerImage7,
            WaterManagerImage8,
            WaterManagerImage9,
            WaterManagerImage10,
            WaterManagerImage11,
        ],
        color: "from-green-500 to-teal-500",
    },
    {
        id: 5,
        title: "Anmol Tours & Travels",
        category: "Corporate Website",
        description: "A modern corporate website for a rental car and bus service provider with clean UI, service listings, and booking features.",
        fullDescription: "A professional corporate website designed for Anmol Tours & Travels, offering rental cars, buses, tempo travelers, and customizable travel packages. The site includes service showcases, pricing sections, customer inquiry forms, and optimized mobile responsiveness. Built with smooth animations and a trustworthy brand-focused design.",
        tech: ["React", "Framer Motion", "WhatsApp Integration"],
        link: "https://anmoltravels.vercel.app",
        images: [
            AnmolTravelsImage1,
            AnmolTravelsImage2,
            AnmolTravelsImage3,
            AnmolTravelsImage4,
            AnmolTravelsImage5,
            AnmolTravelsImage6,
            AnmolTravelsImage7,
            AnmolTravelsImage8,
            AnmolTravelsIImage9,
            AnmolTravelsImage10,
        ],
        color: "from-blue-500 to-cyan-500",
    },
    {
        id: 6,
        title: "FutureMinds",
        category: "Corporate Website",
        description: "High-end company website with advanced animations for organizing summer vacation programs for kids.",
        fullDescription: "An award-winning company website featuring cutting-edge animations and modern design principles. Built for a company organizing summer vacation programs for children, with interactive elements, engaging user experience, advanced CSS animations, and optimized performance for all devices.",
        tech: ["React", "Framer Motion", "GSAP", "CSS3"],
        link: "https://futureminds.fun",
        images: [
            FutureMindsImage1,
            FutureMindsImage2,
            FutureMindsImage3,
            FutureMindsImage4,
            FutureMindsImage5,
            FutureMindsImage6,
            FutureMindsImage7,
            FutureMindsImage8,
        ],
        color: "from-green-500 to-teal-500",
    },
    {
        id: 7,
        title: "Vishwalatarati",
        category: "Corporate Website",
        description:
            "A modern digital solutions company website showcasing software, web, and app development services at affordable prices.",
        fullDescription:
            "A professional and visually engaging company website designed for Vishwalatarati — a digital solutions provider specializing in software, website, and mobile app development. The platform highlights the company’s mission to deliver innovative, high-quality, and cost-effective tech solutions using the latest technologies. Featuring sleek animations, responsive layouts, and an intuitive user interface, the website effectively represents Vishwalatarati’s commitment to empowering businesses through technology and creativity.",
        tech: ["React", "Framer Motion", "EmailJS", "CSS3"],
        link: "https://vishwalatarati.in",
        images: [
            VishwalataratiImage1,
            VishwalataratiImage2,
            VishwalataratiImage3,
            VishwalataratiImage4,
            VishwalataratiImage5,
            VishwalataratiImage6,
            VishwalataratiImage7,
            VishwalataratiImage8,
            VishwalataratiImage9,
            VishwalataratiImage10,
        ],
        color: "from-blue-500 to-cyan-500",
    },
    {
        id: 8,
        title: "TextNTalk",
        isApplication: true,
        category: "Mobile Application",
        description:
            "Advanced Android translation app with supporting five Indian languages.",
        fullDescription:
            "Sophisticated Android application built with Java and XML, featuring ML Kit integration. Supports real-time translation between five Indian languages, includes advanced text-to-speech functionality, image text recognition using machine learning, offline translation capabilities, and AI-powered word descriptions with contextual explanations.",
        tech: ["Android Studio", "Java", "XML", "ML Kit", "Firebase"],
        link: "#",
        images: [
            TextNTalkImage1,
            TextNTalkImage2,
            TextNTalkImage3,
            TextNTalkImage4,
            TextNTalkImage5,
            TextNTalkImage6,
            TextNTalkImage7,
            TextNTalkImage8,
            TextNTalkImage9,
            TextNTalkImage10,
        ],
        color: "from-orange-500 to-red-500",
    },
    {
        id: 9,
        title: "Grocery",
        category: "E-commerce",
        description:
            "An online grocery platform with seamless QR payment integration and billing features.",
        fullDescription:
            "A user-centric online grocery platform designed for a smooth shopping experience, featuring a modern UI, secure qr payment integration, and billing report generation. Customers can browse a wide range of grocery items, place orders with ease. The platform ensures convenience, speed, and reliability, making everyday grocery shopping smarter and more efficient.",
        tech: ["HTML", "Firebase", "Js Canvas", "Signin with Google"],
        link: "https://akhil-8605.github.io/grocery/",
        images: [
            GroceryImage1,
            GroceryImage2,
            GroceryImage3,
            GroceryImage4,
            GroceryImage5,
            GroceryImage6,
            GroceryImage7,
        ],
        color: "from-emerald-500 to-green-500",
    },
    {
        id: 10,
        title: "Student Marks Management",
        category: "Educational Tool",
        description:
            "A comprehensive student marks management system with advanced Excel/image export and detailed reporting features.",
        fullDescription:
            "A powerful and intuitive student marks management system designed to simplify academic performance tracking. It offers advanced features such as subject-wise mark entry, automated grade calculation, and generation of performance reports. The system supports exporting data in both Excel and image formats, making it ideal for documentation and sharing. With customizable reports, clean UI, and accurate analytics, it streamlines result processing for schools, colleges, and coaching centers.",
        tech: ["React", "Chart.js", "ExcelJS", "Canvas", "Local Storage"],
        link: "https://akhil-8605.github.io/student-marks/",
        images: [
            StudentMarksImage1,
            StudentMarksImage2,
            StudentMarksImage3,
            StudentMarksImage4,
            StudentMarksImage5,
        ],
        color: "from-yellow-500 to-orange-500",
    },
    {
        id: 11,
        title: "ProjectNest",
        category: "Marketplace",
        description:
            "A comprehensive online marketplace for engineering students to explore, customize, and purchase final year projects.",
        fullDescription:
            "An all-in-one online marketplace tailored for engineering students to discover, customize, and purchase high-quality final year projects. The platform features a wide range of project categories, including electronics, computer science, mechanical, and civil engineering. With detailed project descriptions, demo videos, source code, and support options, students can easily find solutions that match their academic requirements. Built for convenience and credibility, it empowers students to succeed with ready-to-implement, innovation-driven projects.",
        tech: ["HTML5", "CSS3", "JavaScript"],
        link: "https://akhil-8605.github.io/ProjectNest/",
        images: [
            ProjectNestImage1,
            ProjectNestImage2,
            ProjectNestImage3,
            ProjectNestImage4,
            ProjectNestImage5,
            ProjectNestImage6,
            ProjectNestImage7,
            ProjectNestImage8,
        ],
        color: "from-indigo-500 to-purple-500",
    },
];